import React from 'react'

export class Stamp2020 extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="46.05" height="21.01" viewBox="0 0 46.05 21.01">
			  <g id="Logo2020">
			    <path id="logo_red" fill="#FF0000" d="M11.51,13.4C13.75,12,15.8,9.46,15.8,6.65c0-3.83-3-6.64-7.22-6.64C4.78,0,1.86,2.33.46,6L5.74,9.29,0,20.65H16.07V13.4Zm17,7.6A10.18,10.18,0,0,0,39,11.11v-.63A10.17,10.17,0,0,0,29.15,0h-.61A10.18,10.18,0,0,0,18,9.83c0,.21,0,.43,0,.65A10.19,10.19,0,0,0,27.87,21Q28.22,21,28.56,21Z"/>
			    <path id="logo_cyan" fill="#00FFFF" d="M18.55,13.4c2.23-1.42,4.29-3.94,4.29-6.75,0-3.83-3-6.64-7.22-6.64C11.82,0,8.89,2.33,7.5,6l5.28,3.25L7,20.65H23.1V13.4ZM35.6,21A10.17,10.17,0,0,0,46,11.11q0-.31,0-.63A10.16,10.16,0,0,0,36.19,0h-.62A10.17,10.17,0,0,0,25.05,9.83c0,.21,0,.43,0,.65A10.19,10.19,0,0,0,34.91,21Q35.26,21,35.6,21Z"/>
			    <g>
			      <path fill="#000" d="M32.06.43a10.18,10.18,0,0,0-7,9.32c0,.21,0,.43,0,.65a10.19,10.19,0,0,0,7,10,10.17,10.17,0,0,0,7-9.38q0-.31,0-.63A10.17,10.17,0,0,0,32.06.43Z"/>
			      <path fill="#000" d="M23.1,13.33H18.54c2.24-1.43,4.3-3.95,4.3-6.76a6.46,6.46,0,0,0-1.38-4.06,10.15,10.15,0,0,0-3.41,7.24v.65a10.2,10.2,0,0,0,5.05,9.14Z"/>
			      <path fill="#000" d="M11.56,13.33c2.23-1.43,4.29-3.95,4.29-6.76A6.36,6.36,0,0,0,12.16.68,9.1,9.1,0,0,0,7.49,6l5.28,3.25L7,20.58h9.08V13.33Z"/>
			    </g>
			  </g>
			</svg>
		)
	}
}

export class FacebookIcon extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" id="facebook_icon" width="22.709" height="22.571" viewBox="0 0 22.709 22.571">
			  <path d="M23.271,11.917A11.354,11.354,0,1,0,10.143,23.134V15.2H7.258V11.917h2.884v-2.5C10.143,6.57,11.837,5,14.431,5a17.474,17.474,0,0,1,2.542.222V8.012H15.541a1.641,1.641,0,0,0-1.85,1.773v2.131H16.84l-.5,3.282H13.691v7.935A11.358,11.358,0,0,0,23.271,11.917Z" transform="translate(-0.563 -0.563)" fill="currentColor" />
			</svg>
		)
	}
}

export class TwitterIcon extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" id="twittier_icon" width="23.441" height="19.038" viewBox="0 0 23.441 19.038">
				<path d="M21.032,8.125c.015.208.015.416.015.625A13.575,13.575,0,0,1,7.377,22.419,13.576,13.576,0,0,1,0,20.263a9.939,9.939,0,0,0,1.16.059,9.622,9.622,0,0,0,5.964-2.053,4.813,4.813,0,0,1-4.492-3.332,6.059,6.059,0,0,0,.907.074A5.081,5.081,0,0,0,4.8,14.848,4.8,4.8,0,0,1,.952,10.133v-.059a4.838,4.838,0,0,0,2.172.61A4.811,4.811,0,0,1,1.636,4.258a13.656,13.656,0,0,0,9.906,5.027,5.423,5.423,0,0,1-.119-1.1A4.809,4.809,0,0,1,19.738,4.9a9.459,9.459,0,0,0,3.049-1.16,4.791,4.791,0,0,1-2.112,2.648,9.631,9.631,0,0,0,2.767-.744,10.327,10.327,0,0,1-2.41,2.484Z" transform="translate(0 -3.381)" fill="currentColor" />
			</svg>
		)
	}
}

export class InstagramIcon extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" id="instagram_icon" width="20.523" height="20.518" viewBox="0 0 20.523 20.518">
				<path d="M10.258,7.236A5.261,5.261,0,1,0,15.519,12.5,5.252,5.252,0,0,0,10.258,7.236Zm0,8.681a3.42,3.42,0,1,1,3.42-3.42A3.426,3.426,0,0,1,10.258,15.917Zm6.7-8.9a1.227,1.227,0,1,1-1.227-1.227A1.224,1.224,0,0,1,16.961,7.021Zm3.484,1.245a6.072,6.072,0,0,0-1.657-4.3,6.112,6.112,0,0,0-4.3-1.657c-1.694-.1-6.771-.1-8.465,0a6.1,6.1,0,0,0-4.3,1.653,6.092,6.092,0,0,0-1.657,4.3c-.1,1.694-.1,6.771,0,8.465a6.072,6.072,0,0,0,1.657,4.3,6.12,6.12,0,0,0,4.3,1.657c1.694.1,6.771.1,8.465,0a6.072,6.072,0,0,0,4.3-1.657,6.112,6.112,0,0,0,1.657-4.3c.1-1.694.1-6.767,0-8.461ZM18.257,18.545a3.463,3.463,0,0,1-1.95,1.95c-1.351.536-4.555.412-6.048.412s-4.7.119-6.048-.412a3.463,3.463,0,0,1-1.95-1.95c-.536-1.351-.412-4.555-.412-6.048s-.119-4.7.412-6.048A3.463,3.463,0,0,1,4.21,4.5c1.351-.536,4.555-.412,6.048-.412s4.7-.119,6.048.412a3.463,3.463,0,0,1,1.95,1.95c.536,1.351.412,4.555.412,6.048S18.792,17.2,18.257,18.545Z" transform="translate(0.005 -2.238)" fill="currentColor"/>
			</svg>
		)
	}
}

export class InfoIcon extends React.Component {
	render() {
		return (
			<svg className='footer-open' xmlns="http://www.w3.org/2000/svg" id="info_icon" width="23.395" height="23.395" viewBox="0 0 23.395 23.395">
				<g transform="translate(-2 -2)">
					<path id="Path_22" data-name="Path 22" d="M24.395,13.7A10.7,10.7,0,1,1,13.7,3a10.7,10.7,0,0,1,10.7,10.7Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
					<path id="Path_23" data-name="Path 23" d="M18,24V18" transform="translate(-4.303 -5.378)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
					<path id="Path_24" data-name="Path 24" d="M18,12h0" transform="translate(-4.303 -2.582)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
				</g>
			</svg>
		)
	}
}

export class InfoCloseIcon extends React.Component {
	render() {
		return (
			<svg className='footer-close' xmlns="http://www.w3.org/2000/svg" id="info-close-icon" width="22.494" height="22.495" viewBox="0 0 22.494 22.495">
				<g transform="translate(-6.753 -6.753)">
					<path id="Path_25" data-name="Path 25" d="M20.769,19.546l-2.85-2.85,2.85-2.85a.864.864,0,1,0-1.222-1.222l-2.85,2.85-2.85-2.85a.864.864,0,0,0-1.222,1.222l2.85,2.85-2.85,2.85a.836.836,0,0,0,0,1.222.858.858,0,0,0,1.222,0l2.85-2.85,2.85,2.85a.868.868,0,0,0,1.222,0A.858.858,0,0,0,20.769,19.546Z" transform="translate(1.303 1.304)" fill="currentColor" />
					<path id="Path_26" data-name="Path 26" d="M14.622,4.889a9.729,9.729,0,1,1-6.883,2.85,9.669,9.669,0,0,1,6.883-2.85m0-1.514A11.247,11.247,0,1,0,25.869,14.622,11.245,11.245,0,0,0,14.622,3.375Z" transform="translate(3.378 3.378)" fill="currentColor" />
				</g>
			</svg>
		)
	}
}

export class IconCaption extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
				<path id="icon_caption" d="M31.5,22.5a3,3,0,0,1-3,3h-18l-6,6V7.5a3,3,0,0,1,3-3h21a3,3,0,0,1,3,3Z" transform="translate(-4 -4)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			</svg>
		)
	}
}

export class IconCompass extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
				<g id="icon_compass" transform="translate(-2.5 -2.5)">
					<path id="Path_41" data-name="Path 41" d="M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
					<path id="Path_42" data-name="Path 42" d="M24.36,11.64l-3.18,9.54-9.54,3.18,3.18-9.54Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
				</g>
			</svg>
		)
	}
}

export class IconMinimize extends React.Component {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="feather feather-log-out"
			>
				<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
				<polyline points="16 17 21 12 16 7"></polyline>
				<line x1="21" y1="12" x2="9" y2="12"></line>
			</svg>
		)
	}
}

export class IconFullscreen extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
				<path id="icon_fullscreen" d="M12,4.5H7.5a3,3,0,0,0-3,3V12m27,0V7.5a3,3,0,0,0-3-3H24m0,27h4.5a3,3,0,0,0,3-3V24m-27,0v4.5a3,3,0,0,0,3,3H12" transform="translate(-4 -4)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			</svg>
		)
	}
}

export class IconMute extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="32.707" height="23.081" viewBox="0 0 32.707 23.081">
				<g id="icon_mute" transform="translate(-2.5 -6.46)">
					<path id="Path_15" d="M16.5,7.5,9,13.5H3v9H9l7.5,6Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
					<path id="Path_16" d="M34.5,13.5l-9,9" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
					<path id="Path_17" d="M25.5,13.5l9,9" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
				</g>
			</svg>
		)
	}
}

export class IconShare extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31">
			<g id="icon_share" transform="translate(-5.5 -2.5)">
				<path id="Path_33" data-name="Path 33" d="M6,18V30a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V18" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
				<path id="Path_34" data-name="Path 34" d="M24,9,18,3,12,9" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
				<path id="Path_35" data-name="Path 35" d="M18,3V22.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			</g>
		</svg>
		)
	}
}

export class IconVolume extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="30.997" height="23.081" viewBox="0 0 30.997 23.081">
				<g id="icon_volume" transform="translate(-2.5 -6.46)">
					<path id="Path_18" d="M16.5,7.5,9,13.5H3v9H9l7.5,6Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
					<path id="Path_19" d="M28.6,7.395a15,15,0,0,1,0,21.21M23.31,12.69a7.5,7.5,0,0,1,0,10.605" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
				</g>
			</svg>
		)
	}
}
